import React from 'react';
import Avatar from './images/avatar.webp';
import parse from 'html-react-parser';

const ExternalProfile: React.FC<{
  adminDetail: any;
  isAdminDetailLoading: boolean;
}> = ({ adminDetail, isAdminDetailLoading }) => {
  if (isAdminDetailLoading) {
    return <div className="p-5 text-center">Loading...</div>;
  }

  return (
    <div className="container-fluid p-4">
      <div className="row g-4">
        {/* Left Column: Profile Card */}
        <div className="col-lg-5 col-md-12">
          <div className="card border-0 shadow-sm rounded-4 h-100">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <img
                  src={adminDetail?.image || Avatar}
                  alt="profileImg"
                  className="rounded-circle border border-4 border-light shadow-sm"
                  style={{
                    objectFit: 'cover',
                    height: '180px',
                    width: '180px'
                  }}
                />
              </div>

              <h3 className="fw-bold mb-1">
                {`${adminDetail?.first_name || ''} ${adminDetail?.middle_name || ''} ${adminDetail?.last_name || ''}`}
              </h3>
              <p className="text-primary fw-medium mb-4">
                {adminDetail?.current_position || 'Position not specified'}
              </p>

              <hr className="my-4 opacity-25" />

              <div className="text-start">
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted fw-bold small text-uppercase">Email</span>
                  <span className="text-dark">{adminDetail?.email || '--'}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted fw-bold small text-uppercase">Phone</span>
                  <span className="text-dark">{adminDetail?.mobile_number || '--'}</span>
                </div>
                <div className="d-flex justify-content-between mb-0">
                  <span className="text-muted fw-bold small text-uppercase">Designation</span>
                  <span className="text-dark">{adminDetail?.current_position || '--'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Content Details */}
        <div className="col-lg-7 col-md-12">
          <div className="p-2">
            {/* Bio Section */}
            <section className="mb-5">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-primary rounded-pill me-2" style={{ width: '4px', height: '24px' }}></div>
                <h4 className="fw-bold mb-0">Biography</h4>
              </div>
              <div className="text-secondary lh-lg ps-3">
                {adminDetail?.bio ? parse(adminDetail.bio) : <span className="text-muted italic">No biography data available.</span>}
              </div>
            </section>

            {/* Experience Section */}
            <section className="mb-5">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-primary rounded-pill me-2" style={{ width: '4px', height: '24px' }}></div>
                <h4 className="fw-bold mb-0">Professional Experience</h4>
              </div>
              <div className="text-secondary lh-lg ps-3">
                {adminDetail?.experience ? parse(adminDetail.experience) : <span className="text-muted italic">No experience data available.</span>}
              </div>
            </section>

            {/* Area of Expertise Section */}
            <section className="mb-0">
              <div className="d-flex align-items-center mb-3">
                <div className="bg-primary rounded-pill me-2" style={{ width: '4px', height: '24px' }}></div>
                <h4 className="fw-bold mb-0">Area of Expertise</h4>
              </div>
              <div className="text-secondary lh-lg ps-3">
                {adminDetail?.area_of_expertise ? parse(adminDetail.area_of_expertise) : <span className="text-muted italic">No expertise data available.</span>}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalProfile;